<!-- Webchat component - the actual webchat widget is loaded and rendered by the Cognigy script -->
<div class="webchat-container">
  <!-- The webchat widget will be automatically injected here by the Cognigy script -->
</div>
